"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectStorageLocation;
(function (ProjectStorageLocation) {
    ProjectStorageLocation["EU"] = "eu";
    ProjectStorageLocation["US"] = "us";
    ProjectStorageLocation["AWS_EU_WEST_1"] = "eu-west-1";
    ProjectStorageLocation["AWS_US_EAST_1"] = "us-east-1";
    ProjectStorageLocation["GCP_EU_EAST_4"] = "europe-west4";
    ProjectStorageLocation["GCP_US_EAST_4"] = "us-east4";
})(ProjectStorageLocation = exports.ProjectStorageLocation || (exports.ProjectStorageLocation = {}));
function resolveProjectStorageLocation(storageLocation) {
    switch (storageLocation) {
        case ProjectStorageLocation.EU:
            return ProjectStorageLocation.AWS_EU_WEST_1;
        case ProjectStorageLocation.US:
            return ProjectStorageLocation.AWS_US_EAST_1;
        default:
            return storageLocation;
    }
}
exports.resolveProjectStorageLocation = resolveProjectStorageLocation;
function getCTLocationFromCSLocation(storageLocation) {
    switch (storageLocation) {
        case ProjectStorageLocation.EU:
        case ProjectStorageLocation.AWS_EU_WEST_1:
        case ProjectStorageLocation.GCP_EU_EAST_4:
            return 'EU';
        case ProjectStorageLocation.US:
        case ProjectStorageLocation.AWS_US_EAST_1:
        case ProjectStorageLocation.GCP_US_EAST_4:
            return 'US';
        default:
            return 'NOT DEFINED';
    }
}
exports.getCTLocationFromCSLocation = getCTLocationFromCSLocation;
//# sourceMappingURL=project.storage.location.js.map